var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-grid"},_vm._l((_vm.tippArray),function(tipp,ind){return _c('TippTile',{key:ind,attrs:{"title":tipp.title,"color":tipp.color,"tippClass":tipp.class,"inde":ind}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }